import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

const path = "/management/roadmap-stage";
export const managementKvkkRoadmap = createCrudVuexModule({
  namespaced: true,
  path,
  state: {
    editedTask: undefined,
    tasks: [],
    editedStages: [],
    //
    descriptionProductTutorial: undefined,
    descriptionDepartmentQuestions: undefined,
    descriptionInventoryUpdate: undefined,
    descriptionKvkkPolicy: undefined,
    descriptionKvkkRisk: undefined,
    descriptionReportPrepare: undefined,
    //
    isProductTutorialLoading: false,
    isDepartmentQuestionsLoading: false,
    isInventoryUpdateLoading: false,
    isKvkkPolicyLoading: false,
    isKvkkRiskLoading: false,
    isReportPrepareLoading: false,
  },
  getters: {
    editedTask: (state) => state.editedTask,
    tasks: (state) => state.tasks,
    editedStages: (state) => state.editedStages,
    //
    descriptionProductTutorial: (state) => state.descriptionProductTutorial,
    descriptionDepartmentQuestions: (state) => state.descriptionDepartmentQuestions,
    descriptionInventoryUpdate: (state) => state.descriptionInventoryUpdate,
    descriptionKvkkPolicy: (state) => state.descriptionKvkkPolicy,
    descriptionKvkkRisk: (state) => state.descriptionKvkkRisk,
    descriptionReportPrepare: (state) => state.descriptionReportPrepare,
    //
    isProductTutorialLoading: (state) => state.isProductTutorialLoading,
    isDepartmentQuestionsLoading: (state) => state.isDepartmentQuestionsLoading,
    isInventoryUpdateLoading: (state) => state.isInventoryUpdateLoading,
    isKvkkPolicyLoading: (state) => state.isKvkkPolicyLoading,
    isKvkkRiskLoading: (state) => state.isKvkkRiskLoading,
    isReportPrepareLoading: (state) => state.isReportPrepareLoading,
  },
  mutations: {
    reset: (state, value) => {
      state.editedTask = undefined;
      state.tasks = [];
      state.editedStages = [];

      state.descriptionProductTutorial = undefined;
      state.descriptionDepartmentQuestions = undefined;
      state.descriptionInventoryUpdate = undefined;
      state.descriptionKvkkPolicy = undefined;
      state.descriptionKvkkRisk = undefined;
      state.descriptionReportPrepare = undefined;

      state.isProductTutorialLoading = false;
      state.isDepartmentQuestionsLoading = false;
      state.isInventoryUpdateLoading = false;
      state.isKvkkPolicyLoading = false;
      state.isKvkkRiskLoading = false;
      state.isReportPrepareLoading = false;

      state.isUpdating = false;
      state.isLoading = false;
    },

    clearEditedStages: (state, value) => (state.editedStages = []),

    isProductTutorialLoading: (state, value) => (state.isProductTutorialLoading = value),
    isDepartmentQuestionsLoading: (state, value) => (state.isDepartmentQuestionsLoading = value),
    isInventoryUpdateLoading: (state, value) => (state.isInventoryUpdateLoading = value),
    isKvkkPolicyLoading: (state, value) => (state.isKvkkPolicyLoading = value),
    isKvkkRiskLoading: (state, value) => (state.isKvkkRiskLoading = value),
    isReportPrepareLoading: (state, value) => (state.isReportPrepareLoading = value),

    descriptionProductTutorial: (state, value) => {
      state.descriptionProductTutorial = value;
      if (!state.editedStages.includes("KVKK_PRODUCT_TUTORIAL")) {
        state.editedStages.push("KVKK_PRODUCT_TUTORIAL");
      }
    },
    descriptionDepartmentQuestions: (state, value) => {
      state.descriptionDepartmentQuestions = value;
      if (!state.editedStages.includes("KVKK_DEPARTMENT_QUESTIONS")) {
        state.editedStages.push("KVKK_DEPARTMENT_QUESTIONS");
      }
    },
    descriptionInventoryUpdate: (state, value) => {
      state.descriptionInventoryUpdate = value;
      if (!state.editedStages.includes("KVKK_INVENTORY_UPDATE")) {
        state.editedStages.push("KVKK_INVENTORY_UPDATE");
      }
    },
    descriptionKvkkPolicy: (state, value) => {
      state.descriptionKvkkPolicy = value;
      if (!state.editedStages.includes("KVKK_POLICY")) {
        state.editedStages.push("KVKK_POLICY");
      }
    },
    descriptionKvkkRisk: (state, value) => {
      state.descriptionKvkkRisk = value;
      if (!state.editedStages.includes("KVKK_RISK")) {
        state.editedStages.push("KVKK_RISK");
      }
    },
    descriptionReportPrepare: (state, value) => {
      state.descriptionReportPrepare = value;

      if (!state.editedStages.includes("KVKK_REPORT_PREPARE")) {
        state.editedStages.push("KVKK_REPORT_PREPARE");
      }
    },

    editedTask: (state, value) => (state.editedTask = value),

    addTaskItemsToStage: (state, { task }) => {
      if (!state.editedStages.includes(task.stage)) {
        state.editedStages.push(task.stage);
      }

      if (!task._id) {
        task._id = "id" + new Date().getTime(); //id atama
      }

      state.tasks = [...state.tasks, { ...task }];
    },
    updateTaskItemsToStage: (state, { task }) => {
      if (!state.editedStages.includes(task.stage)) {
        state.editedStages.push(task.stage);
      }

      state.tasks = state.tasks.map((t) => {
        if (t._id == task._id) {
          t = task;
        }

        t.blockedByTasks = t.blockedByTasks?.map((x) => {
          if (x._id == task._id) {
            return task;
          }
          return x;
        });

        return t;
      });
    },

    removeTaskItem: (state, { task }) => {
      if (!state.editedStages.includes(task.stage)) {
        state.editedStages.push(task.stage);
      }

      state.tasks = state.tasks.filter((t) => t._id != task._id);
    },
  },
  actions: {
    async save({ getters, commit, dispatch }) {
      try {
        commit("isUpdating", true);

        const response = await Promise.all(
          getters.editedStages.map(async (stage) => {
            let payload = {
              tasks: getters.tasks.filter((t) => t.stage == stage),
              roadmapDefinition: "KVKK_PRODUCT_ROADMAP",
              definition: stage,
              description: null,
              next: null,
            };

            if (stage == "KVKK_PRODUCT_TUTORIAL") {
              payload.description = getters.descriptionProductTutorial;
              payload.first = true;
              payload.next = ["KVKK_DEPARTMENT_QUESTIONS"];
            } else if (stage == "KVKK_DEPARTMENT_QUESTIONS") {
              payload.description = getters.descriptionDepartmentQuestions;
              payload.next = ["KVKK_INVENTORY_UPDATE"];
            } else if (stage == "KVKK_INVENTORY_UPDATE") {
              payload.description = getters.descriptionInventoryUpdate;
              payload.next = ["KVKK_POLICY"];
            } else if (stage == "KVKK_POLICY") {
              payload.description = getters.descriptionKvkkPolicy;
              payload.next = ["KVKK_RISK"];
            } else if (stage == "KVKK_RISK") {
              payload.description = getters.descriptionKvkkRisk;
              payload.next = ["KVKK_REPORT_PREPARE"];
            } else if (stage == "KVKK_REPORT_PREPARE") {
              payload.description = getters.descriptionReportPrepare;
            }

            try {
              commit("isUpdating", true);
              payload = await dispatch("preparePayload", {
                editedEntity: {},
                form: payload,
              });

              const response = await rest.put(`${path}`, { item: payload });
              return response;
            } catch (e) {
              console.error(e);
            }
          })
        );

        return response;
      } finally {
        commit("reset");
      }
    },

    async loadStages({ getters, rootGetters, commit, dispatch }) {
      try {
        commit("reset");

        const language = rootGetters["user/account"].language ?? "tr";
        const stages = ["KVKK_PRODUCT_TUTORIAL", "KVKK_DEPARTMENT_QUESTIONS", "KVKK_INVENTORY_UPDATE", "KVKK_POLICY", "KVKK_RISK", "KVKK_REPORT_PREPARE"];
        const response = await Promise.all(
          stages.map(async (stage) => {
            try {
              if (stage == "KVKK_PRODUCT_TUTORIAL") {
                commit("isProductTutorialLoading", true);
              } else if (stage == "KVKK_DEPARTMENT_QUESTIONS") {
                commit("isDepartmentQuestionsLoading", true);
              } else if (stage == "KVKK_INVENTORY_UPDATE") {
                commit("isInventoryUpdateLoading", true);
              } else if (stage == "KVKK_POLICY") {
                commit("isKvkkPolicyLoading", true);
              } else if (stage == "KVKK_RISK") {
                commit("isKvkkRiskLoading", true);
              } else if (stage == "KVKK_REPORT_PREPARE") {
                commit("isReportPrepareLoading", true);
              }

              const response = await rest.post(`${path}`, { roadmapDefinition: "KVKK_PRODUCT_ROADMAP", definition: stage });
              if (response?.data && typeof response.data === "object") {
                if (response.data.description) {
                  const description = response.data.description[language];

                  if (stage == "KVKK_PRODUCT_TUTORIAL") {
                    commit("descriptionProductTutorial", description);
                  } else if (stage == "KVKK_DEPARTMENT_QUESTIONS") {
                    commit("descriptionDepartmentQuestions", description);
                  } else if (stage == "KVKK_INVENTORY_UPDATE") {
                    commit("descriptionInventoryUpdate", description);
                  } else if (stage == "KVKK_POLICY") {
                    commit("descriptionKvkkPolicy", description);
                  } else if (stage == "KVKK_RISK") {
                    commit("descriptionKvkkRisk", description);
                  } else if (stage == "KVKK_REPORT_PREPARE") {
                    commit("descriptionReportPrepare", description);
                  }
                }

                response.data.tasks.forEach((task) => {
                  task.stage = stage;
                  task.description = task.description;
                  commit("addTaskItemsToStage", { task });
                });
              }
              return response?.data;
            } catch (e) {
              console.error(e);
            } finally {
              if (stage == "KVKK_PRODUCT_TUTORIAL") {
                commit("isProductTutorialLoading", false);
              } else if (stage == "KVKK_DEPARTMENT_QUESTIONS") {
                commit("isDepartmentQuestionsLoading", false);
              } else if (stage == "KVKK_INVENTORY_UPDATE") {
                commit("isInventoryUpdateLoading", false);
              } else if (stage == "KVKK_POLICY") {
                commit("isKvkkPolicyLoading", false);
              } else if (stage == "KVKK_RISK") {
                commit("isKvkkRiskLoading", false);
              } else if (stage == "KVKK_REPORT_PREPARE") {
                commit("isReportPrepareLoading", false);
              }
            }
          })
        );

        return response;
      } catch (e) {
        console.error(e);
      } finally {
        commit("clearEditedStages");
      }
    },
  },
});
